import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { safeJsonInput } from '../../../shared/_utils/safe-json-input';

/**
 * Angular CE for Admin Email Settings page (Wave 3 batch).
 * Parity: title "Email Settings" and settings-list section from original AngularJS email-settings-tpl.
 */
@Component({
    selector: 'gtw-email-settings',
    templateUrl: './email-settings.component.html',
    styleUrls: ['./email-settings.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class EmailSettingsComponent {
  @Input('header-data')
  set _header_data(v: string) {
    const h = typeof v === 'string'
      ? safeJsonInput<any>(v, null, 'email-settings.header-data')
      : v;
    if (h && Object.keys(h).length > 0) {
      this.headerData = h;
    }
  }
  headerData: any = {};
}
